// extracted by mini-css-extract-plugin
module.exports = {"faq":"Faq_faq__80UxT","heading":"Faq_heading__z6F68","collapse":"Faq_collapse__FG1b6"};